import { useState } from 'react'

import { SelectOption } from '../../AstraSelect'
import { MultiSelectOption } from '../types/types'
import { COLLAPSED_GROUP_PLACEHOLDER, isGroup } from '../utils/utils'

export const useMultiSelectData = <T>(options: MultiSelectOption<T>[], values: T[], expandedGroups: boolean) => {
    const [openGroups, setOpenGroups] = useState<Record<string, boolean>>({})

    const selectedOptions: SelectOption<T>[] = []
    const groups: Array<{ label: string; options: SelectOption<T>[] }> = []
    const valueToGroupLabel = new Map<T, string>()
    const fullySelectedGroups = new Set<string>()
    const filteredOptions: MultiSelectOption<T>[] = []

    for (const opt of options) {
        if (isGroup(opt)) {
            groups.push(opt)
            const expanded = openGroups[opt.label] ?? expandedGroups
            let allSelected = opt.options.length > 0
            const annotated = opt.options.map(o => {
                valueToGroupLabel.set(o.value, opt.label)
                if (values.includes(o.value)) {
                    selectedOptions.push(o)
                } else {
                    allSelected = false
                }
                return { ...o, groupLabel: opt.label }
            })
            if (allSelected) fullySelectedGroups.add(opt.label)
            if (expanded) {
                filteredOptions.push({ ...opt, options: annotated })
            } else {
                filteredOptions.push({
                    ...opt,
                    options: [{ value: `${COLLAPSED_GROUP_PLACEHOLDER}${opt.label}`, label: '' } as SelectOption<T>],
                })
            }
        } else {
            const copy = { ...opt }
            if (values.includes(copy.value)) selectedOptions.push(copy)
            filteredOptions.push(copy)
        }
    }

    const groupedOptionValues = new Set(options.filter(isGroup).flatMap(group => group.options.map(opt => opt.value)))

    return { selectedOptions, groups, valueToGroupLabel, fullySelectedGroups, filteredOptions, openGroups, setOpenGroups, groupedOptionValues }
}
